import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { Labels } from 'src/app/constants/labels';
import { RoutePath } from 'src/app/constants/routerPath';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { SrcPath } from 'src/app/constants/srcPath';
import { KEYS } from 'src/app/constants/keys';
import { isData } from 'src/app/utils/utils';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports:[CommonModule,SharedModule]
})
export class MenuComponent implements OnInit {

  headerData: ColumnHeader | any;
  menuListdata: any;
  menuParentListdata: any;
  menuChildListdata: any;
  menuParentId: any = '0';
  previousParentId: any = '0';
  parentModuleId: any = '0';
  customerId: string | any;
  labelMessages = Labels.messages;
  labelButton = Labels.buttons;
  bsModalRef!: BsModalRef;
  srcPath = SrcPath;
  isSuperaDmin: boolean = false;
  dbPath: any;
  menuParentName: any = '';

  moduleListdata: any = [];
  menuWiseChildListdata: any = [];
  menumoduleorderData: any;
  staticPageslist!: any[];
  adminMenuIcon = SrcPath.adminMenuIcon;
  messageLabel = Labels.messages;

  constructor(private router: Router, private commonService: CommonService, private toastr: ToastrService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.loadStaticMenu();
    this.initColumnHeader(Labels.menu.title, true, this.labelButton.create_new_menu, false, '', '', '');
    this.customerId = (this.commonService.getUserCredentials(KEYS.credential_customer_id));
    this.LoadMenu();
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initColumnHeader(title: string, btnShow: boolean, name: string, topbtnShow: boolean, prptitle: string, prpicon: string, prpclass: string) {
    this.headerData = {
      title: title,
      button: {
        show: btnShow,
        name: name
      },
      topButton: {
        show: topbtnShow,
        property: [
          {
            title: prptitle,
            icon: prpicon,
            class: prpclass
          }
        ]

      }
    };
  }

  LoadMenu() {
    this.menuListdata = [];
    this.previousParentId = '0';
    this.menuChildListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenuforAdmin(dbFullPath, this.customerId).subscribe((data: any) => {

      if (isData(data)) {
        this.menuListdata = data['table'];

        this.staticPageslist.forEach((element: any) => {
          this.menuListdata.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'gstibo_tooltip_name': element.gstibo_tooltip_name,
              'moduleid': element.gstibo_menu_id,
              'module_id': element.gstibo_menu_id,
              'gstibo_menu_icon': 'timesheet',
              'pgid': element.gstibo_page_id,
              'child': data['table'].filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0),
              'pagetype': 'S',
              'gstibo_parent_menu_id': element.gstibo_is_show_parentmodule_Id,
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder),
              'gstibo_listing_order': element.gstibo_listing_order,
              'gstibo_is_show_parentmodule_Id': element.gstibo_is_show_parentmodule_Id,
              'gstibo_is_show_parentmodule': element.gstibo_is_show_parentmodule,
              'gstibo_is_show_in_dynamic_menu': element.gstibo_is_show_in_dynamic_menu,
              'gstibo_is_hide': element.gstibo_is_hide,
            });

        });
        this.moduleListdata = data['table'].filter((x: any) => x.gstibo_parent_menu_id == 0);


        this.moduleListdata.forEach((element: any) => {
          let childmenues = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == element.gstibo_menu_id);
          childmenues = childmenues.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
          const subchildmenue = childmenues.filter((y: any) => y.gstibo_with_child_inner_page == '1');
          const childmenueFilter = subchildmenue.map((x: any) => x.gstibo_menu_id);
          let filterControls = this.menuListdata.filter((x: any) => childmenueFilter.includes(x.gstibo_parent_menu_id));
          let childPages = [];
          // childmenues.forEach(child => {  
          //   let pages =this.menuListdata.filter((x: any)=>x.gstibo_with_menu_group_id == child.gstibo_menu_id);
          //   // pages.forEach(ele => { 
          //   //   childPages.push(ele);
          //   // });


          //         });
          this.menuWiseChildListdata.push(
            {
              'parent_menu_name': element.gstibo_menu_name,
              'parent_menu_id': element.gstibo_menu_id,
              'with_child_inner_page': element.gstibo_with_child_inner_page,
              // 'gstibo_menu_name': child.gstibo_menu_name,
              // 'gstibo_menu_id': child.gstibo_menu_id,
              'child': childmenues,
              'sub_child': filterControls,
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder)
            });

        });

      } else {
        this.commonService.ogLog('data not available');
      }
      this.menuWiseChildListdata = this.menuWiseChildListdata.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
      // if (isData(data)) {
      //   this.menuListdata = data['table'];
      //   this.menuChildListdata = data['table'].filter((x: any)=>x.gstibo_parent_menu_id == this.menuParentId);
      //   console.log("menuListdata", this.menuListdata);

      // } else {
      //   console.log('data not available');
      // }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
  }

  viewChild(parentId: any, moduleid: any) {
    if (this.previousParentId != '0' && moduleid == this.parentModuleId) {
      this.previousParentId = '0';
      this.parentModuleId = '0';
    }
    else {
      this.previousParentId = this.menuParentId;
      this.commonService.ogLog('parentId : ', parentId);
      this.menuParentId = parentId;
      let parentMenu = this.menuListdata.filter((x: any) => x.gstibo_menu_id == parentId);
      this.parentModuleId = parentMenu[0].moduleid;
      this.menuParentName = parentMenu[0].gstibo_menu_name;
      this.menuChildListdata = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == parentId);
      this.commonService.ogLog('this.menuChildListdata : ', this.menuChildListdata);
    }
    //this.initColumnHeader(Labels.menu.title, false, '', true, Labels.menu.prptitle, SrcPath.previousIcon, Labels.menu.class);
  }

  editMenu(menu_id: any) {
    const menuDetails = this.menuListdata.filter((data: any) => data.gstibo_menu_id == menu_id);
    this.commonService.ogLog('menuDetails:', menuDetails);
    this.router.navigate([RoutePath.createMenu],
      {
        queryParams: {
          menu_id: menu_id,
          menuDetails: JSON.stringify(menuDetails)
        }
      });
  }

  AddSubMenu(parent_menu_id: any) {
    this.router.navigate(['/dashboard/menu/createmenu'], { queryParams: { inputMode: KEYS.actionType.add, parent_menu_id: parent_menu_id, menu_type: KEYS.actionType.edit } });
  }

  menuBack() {
    if (this.menuParentId != 0) {
      this.previousParentId = this.menuListdata.filter((x: any) => x.gstibo_menu_id == this.menuParentId)[0].gstibo_parent_menu_id;
      this.menuParentId = this.previousParentId;
      this.menuChildListdata = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == this.previousParentId);
    }
    if (this.previousParentId == 0) {
      this.initColumnHeader(Labels.menu.title, true, this.labelButton.create_new_menu, false, '', '', '');
    }
  }

  deleteMenu(menu_id: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.delete_confirm_msg.title,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: 'Yes',
      btnCancel: 'Cancel',
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deleteMenu(dbFullPath, menu_id, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
          this.LoadMenu();
          //this.toastr.success(this.labelMessages.delete_success_msg.message);
          this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
        });
      }
    });
  }
  loadOrderMenuData(menuid: any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data: any) => {
      if (isData(data)) {
        if (this.menumoduleorderData.length == 0) {
          this.menumoduleorderData = data['table'];
        }
      }
    });
  }
  loadStaticMenu() {

    let userAccountID = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.loadStaticMenuForUser(userAccountID).subscribe((data: any) => {
      if (isData(data)) {
        this.staticPageslist = [];
        this.staticPageslist = data['table'];
        // this.staticPageslist.forEach((element:any) => {
        // this.pageListData.push({
        //   'gstibo_menu_name': element.gstibo_menu_name,
        //   'gstibo_page_name':element.gstibo_menu_name,
        //   'gstibo_menu_id': element.gstibo_menu_id,
        //   'moduleid': element.gstibo_menu_id, 
        //   'gstibo_icon': 'timesheet',  
        //   'pgid': element.gstibo_page_id, 
        //   'pagetype': 'S',
        //   'gstibo_with_menu_group_id' :element.gstibo_menu_id
        // })

        // });
      }
    });
  }
}
